// extracted by mini-css-extract-plugin
export var bannerImage = "styles-module__bannerImage___TB8OY";